import { relevantSearchActionConstants } from "../actions/relevantSearch.actions";

export const initialState = {
  scheme: [],
  relatedLangs: [],
  facets: [],
  currentLang: "",
  isBible: false
};

const relevantSearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case relevantSearchActionConstants.ACTION_RELATED_TYPE: {
      const { isBible } = action.data;
      let newState = { ...state };
      newState.isBible = isBible;
      return newState;
    }
    case relevantSearchActionConstants.FETCH_RELEVANT_SEARCH_SCHEME_SUCCESS: {
      const { sections, relatedLangs } = action.data;
      let newState = { ...state };
      if (sections) {
        newState.scheme = sections;
      }
      if (relatedLangs) {
        newState.relatedLangs = relatedLangs;
      }
      return newState;
    }
    case relevantSearchActionConstants.FETCH_RELEVANT_SEARCH_FACET_SUCCESS: {
      const { code, results } = action.data;
      let newState = { ...state };
      newState.facets[code] = results.facets;
      // newState.facets['time'] = Date.now() ;

      return newState;
    }
    case relevantSearchActionConstants.FETCH_RELEVANT_SEARCH_FACET_AGGREGATE_SUCCESS: {
      const { results, lang } = action.data;
      const newState = { ...state };
      const newFacets = { ...state.facets };
      Object.keys(results).forEach((code) => {
        const result = results[code];
        newFacets[code] = result?.facets || [];
      });
      newState.facets = newFacets;
      newState.currentLang = lang ? lang : "";
      return newState;
    }
    case relevantSearchActionConstants.ACTION_CHANGE_RELATED_LANG: {
      const { lang } = action.data;
      let newState = { ...state };
      newState.currentLang = lang ? lang : "";
      return newState;
    }

    default:
      return state;
  }
};

export default relevantSearchReducer;
